import { GetAllCoeficientesAmortizacionDtoProps } from "./DTOs/GetAllCoeficientesAmortizacionDto"

export const getCoeficienteAmortizacionAdapter = (
  coeficiente: GetAllCoeficientesAmortizacionDtoProps
): GetAllCoeficientesAmortizacionDtoProps => ({
  id: coeficiente.id,
  categoria: coeficiente.categoria,
  coeficienteLinealMaximo: coeficiente.coeficienteLinealMaximo,
  nombre: coeficiente.nombre,
  periodoEnAnyos: coeficiente.periodoEnAnyos,
})
